const industries = [
  {
    icon: 'ri-flask-line',
    title: 'Pharmaceutical',
    desc: 'APIs, excipients, finished dosage forms and development services — sourced from audited, compliant manufacturers worldwide.',
    tags: ['APIs', 'Excipients', 'Finished Dosage', 'GMP Certified'],
    image: 'https://public.readdy.ai/ai/img_res/5fc0ae4222fcf5261ca0c6314a7c6088.jpg',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Food',
    desc: 'Ingredients, additives, and specialty food components sourced with full traceability and regulatory compliance for all markets.',
    tags: ['Ingredients', 'Additives', 'HACCP', 'Traceability'],
    image: 'https://readdy.ai/api/search-image?query=modern%20food%20processing%20facility%20with%20stainless%20steel%20production%20lines%20conveyor%20belts%20and%20food%20grade%20equipment%20bright%20clean%20industrial%20setting%20with%20warm%20natural%20tones%20professional%20food%20manufacturing%20plant&width=600&height=400&seq=industry-food-001&orientation=landscape',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Industrial',
    desc: 'Specialty chemicals, raw materials and industrial inputs consolidated and delivered through a single trusted sourcing partner.',
    tags: ['Specialty Chemicals', 'Raw Materials', 'Consolidated Supply'],
    image: 'https://readdy.ai/api/search-image?query=large%20industrial%20manufacturing%20plant%20with%20heavy%20machinery%20production%20equipment%20and%20workers%20in%20safety%20gear%20warm%20amber%20and%20steel%20tones%20professional%20industrial%20facility%20with%20pipes%20and%20processing%20equipment&width=600&height=400&seq=industry-industrial-001&orientation=landscape',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Mining',
    desc: 'Reagents, processing chemicals and consumables for mining operations — reliably sourced, consolidated and managed across global supply chains.',
    tags: ['Reagents', 'Processing Chemicals', 'Consumables'],
    image: 'https://readdy.ai/api/search-image?query=open%20pit%20mining%20operation%20with%20large%20excavators%20and%20haul%20trucks%20at%20golden%20hour%20warm%20earthy%20tones%20dramatic%20landscape%20with%20mining%20equipment%20and%20processing%20facilities%20in%20background%20professional%20industrial%20photography&width=600&height=400&seq=industry-mining-001&orientation=landscape',
  },
];

export default function IndustriesSection() {
  return (
    <section className="w-full px-6 md:px-16 py-20 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <span className="text-emerald-700 text-xs font-bold uppercase tracking-widest block mb-3">
            Industries Served
          </span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-stone-900 leading-tight"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Sectors We Serve
          </h2>
          <p className="text-stone-500 text-base mt-3 max-w-2xl leading-relaxed">
            From regulated pharmaceutical supply chains to heavy industry and food production — MAX-Sourcing delivers qualified, compliant sourcing solutions across key sectors.
          </p>
        </div>

        {/* Industry cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map(({ icon, title, desc, tags, image }) => (
            <div
              key={title}
              className="group rounded-lg border border-stone-100 overflow-hidden flex flex-col"
            >
              {/* Image */}
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 p-5 bg-stone-50">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-emerald-100">
                    <i className={`${icon} text-emerald-700 text-sm`} />
                  </div>
                  <h4
                    className="text-base font-extrabold text-stone-900"
                    style={{ fontFamily: "'DM Serif Display', serif" }}
                  >
                    {title}
                  </h4>
                </div>
                <p className="text-xs text-stone-500 leading-relaxed mb-4 flex-1">{desc}</p>
                <div className="flex flex-wrap gap-1.5">
                  {tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs font-semibold bg-white border border-stone-200 text-stone-600 px-2 py-0.5 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}